import React, { FunctionComponent } from 'react';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import { LabelSeries } from 'react-vis';

import { theme } from 'config';
import ReportBase, { ReportParams } from 'scenes/Report/components/ReportBase';
import Query from 'scenes/Report/components/Query';
import BarChart from 'scenes/Report/components/BarChart/BarChart';
import { tickFormatYAxis } from 'scenes/Report/Report.helper';
import { WithRouterProps } from 'helpers/types';

import GET_CONTROL_GROUP from '../ControlGroupReports.queries';
import {
  OverallLift,
  barTransformer,
  labelTransformer,
} from '../ControlGroupReports.helpers';

type Props = WithRouterProps & {
  height?: number;
};

type QueryResponse = {
  controlGroup: {
    salesPerSubscriber: OverallLift;
    overallLiftPercent: number;
  };
};

const legendItems = [
  {
    title: 'Indexed Sales Per Subscriber',
    color: theme.violet,
  },
];

const renderReport = (params: ReportParams, { height = 450 }: Props) => ({
  controlGroup,
}: QueryResponse) => {
  const { salesPerSubscriber = null, overallLiftPercent = 0 } =
    controlGroup || {};

  const barValue = salesPerSubscriber ? barTransformer(salesPerSubscriber) : [];

  return (
    <ReportBase
      batchKey="salesPerSubscriberOverallLift"
      header="Sales Per Subscriber Overall Lift"
      params={params}
    >
      <BarChart
        height={height}
        legendItems={legendItems}
        tickFormatYAxis={tickFormatYAxis}
        data={barValue}
        title="Sales Per Subscriber Overall Lift"
        hintFormat="$.3"
        crosshair
      >
        <LabelSeries
          data={labelTransformer(barValue, overallLiftPercent, '$.3')}
          labelAnchorX="middle"
        />
      </BarChart>
    </ReportBase>
  );
};

const SalesPerSubscriberOverallLift: FunctionComponent<Props> = (props) => {
  const params = queryString.parse(props.location.search) as ReportParams;

  return (
    <Query
      queryKey="controlGroup"
      query={GET_CONTROL_GROUP}
      reportName="Sales Per Subscriber Overall Lift"
      batchKey="salesPerSubscriberOverallLift"
      variables={{ params }}
      render={renderReport(params, props)}
    />
  );
};

export default withRouter(SalesPerSubscriberOverallLift);
